import { render, staticRenderFns } from "./QuotationTypesForm.vue?vue&type=template&id=1833e144&lang=html"
import script from "./QuotationTypesForm.vue?vue&type=script&lang=js"
export * from "./QuotationTypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports